<div class="smidemenu-container">
    <ul class="menu">
        <li *ngFor="let m of menus">
            <a mat-button [matTooltip]="m.label" *ngIf="[m.permission,m.permissionAction] | builderPermissions" matTooltipPosition="right" (click)="selectOption(m.label)" [class.active]="m.label == selectedSection">  <i class="mdi" [class]="m.icon"></i></a> 
        </li> 
    </ul>
</div>
